import { useEffect, useRef, useState } from 'react'
import {
  DashboardCatalogGroup,
  DashboardGroupGrant,
  fetchDashboardAPI,
} from '../../../svetofor-dashboard/api'
import { dashboardAccessKey } from '../utils/roleDashboardAccess'

export const useRoleDashboardAccess = (roleId?: number) => {
  const [catalog, setCatalog] = useState<DashboardCatalogGroup[]>([])
  const [grants, setGrants] = useState<DashboardGroupGrant[]>([])
  const [savedGrants, setSavedGrants] = useState<DashboardGroupGrant[]>([])
  const [revision, setRevision] = useState(0)
  const [loading, setLoading] = useState(true)
  const [loadError, setLoadError] = useState('')
  const [search, setSearch] = useState('')
  const [onlySelected, setOnlySelected] = useState(false)
  const [expandedGroups, setExpandedGroups] = useState<Set<number>>(new Set())
  const [reload, setReload] = useState(0)
  const requestId = useRef(0)

  useEffect(() => {
    const request = ++requestId.current
    setCatalog([])
    setGrants([])
    setSavedGrants([])
    setRevision(0)
    setSearch('')
    setOnlySelected(false)
    setExpandedGroups(new Set())
    setLoadError('')
    if (!roleId) {
      setLoading(false)
      return
    }
    setLoading(true)
    Promise.all([
      fetchDashboardAPI('/api/admin/svetofor-dashboard/catalog'),
      fetchDashboardAPI(`/api/admin/svetofor-dashboard/roles/${roleId}`),
    ])
      .then(([groups, settings]) => {
        if (request !== requestId.current) return
        if (
          !Array.isArray(groups) ||
          !Array.isArray(settings.groups) ||
          !Number.isSafeInteger(settings.revision)
        )
          throw new Error('Некорректный ответ сервера')
        setCatalog(groups)
        setGrants(settings.groups)
        setSavedGrants(settings.groups)
        setRevision(settings.revision)
        const firstSelective = settings.groups.find(
          (grant: DashboardGroupGrant) => !grant.all && grant.indicatorIds.length,
        )
        if (firstSelective) setExpandedGroups(new Set([firstSelective.groupId]))
      })
      .catch(cause => {
        if (request === requestId.current) setLoadError(cause.message)
      })
      .finally(() => {
        if (request === requestId.current) setLoading(false)
      })
    return () => {
      requestId.current++
    }
  }, [roleId, reload])

  const acceptSaved = (settings: { groups: DashboardGroupGrant[]; revision: number }) => {
    setGrants(settings.groups)
    setSavedGrants(settings.groups)
    setRevision(settings.revision)
  }
  return {
    catalog,
    grants,
    setGrants,
    revision,
    loading,
    loadError,
    search,
    setSearch,
    onlySelected,
    setOnlySelected,
    expandedGroups,
    setExpandedGroups,
    reload: () => setReload(value => value + 1),
    reset: () => setGrants(savedGrants),
    acceptSaved,
    dirty: dashboardAccessKey(grants) !== dashboardAccessKey(savedGrants),
  }
}

export type RoleDashboardAccessModel = ReturnType<typeof useRoleDashboardAccess>
